import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Inject, input, OnInit } from '@angular/core';
import { APP_ICON_API_SERVICE_TOKEN, AppIconApiService } from '@nk/api-lib';
import { AppIconEntity, WithUuid } from '@nk/data-entities-lib';
import { FlagIconComponent } from '@nk/ui-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const COMPANY_FLAG_CATEGORY_KEY_DICT = {
  info: 'info',
  warning: 'warning',
  danger: 'danger',
} as const;

const COMPANY_FLAG_CATEGORY_COLOR_DICT = {
  info: 'text-white',
  warning: 'text-black',
  danger: 'text-white',
} as const;

function isCompanyFlagCategoryKey(key: unknown): key is keyof typeof COMPANY_FLAG_CATEGORY_KEY_DICT {
  return typeof key === 'string' && key in COMPANY_FLAG_CATEGORY_KEY_DICT;
}

@Component({
  selector: 'nk-company-flag-icon',
  imports: [AsyncPipe, FlagIconComponent],
  templateUrl: './company-flag-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyFlagIconComponent implements OnInit {
  public companyFlagTypeAppIconUuid = input.required<string>();
  public companyFlagCategoryKey = input<string>('');
  public companyFlagCategoryColor = computed(() => {
    const key = this.companyFlagCategoryKey();
    if (isCompanyFlagCategoryKey(key)) {
      return COMPANY_FLAG_CATEGORY_KEY_DICT[key];
    }
    return '';
  });
  /**
   *  one of lg, 2x, 3x etc.. See fontawesome documentation (fa- will be prefixed)
   */
  public size = input<string>('');
  public andClass = input<string>('');
  public colorClassOverride = computed(() => {
    const key = this.companyFlagCategoryKey();
    if (isCompanyFlagCategoryKey(key)) {
      return COMPANY_FLAG_CATEGORY_COLOR_DICT[key];
    }
    return '';
  });
  public currentIcon$!: Observable<WithUuid<AppIconEntity>>;

  constructor(
    @Inject(APP_ICON_API_SERVICE_TOKEN)
    private _appIconService: AppIconApiService,
  ) {}

  public ngOnInit(): void {
    this.currentIcon$ = this._appIconService.appIconDictCache
      .getStableCache()
      .pipe(map((dict) => dict[this.companyFlagTypeAppIconUuid()]));
  }
}
